import type { SessionsFilterState } from '../../../types/dashboardV2';
import type { MobileSessionsFilterState } from '../../../types/mobileFilterSheetTypes';

/** Page filters -> mobile-sheet draft (drops `search`; '' status -> null). */
export const toMobileSessionsFilters = (
  filters: SessionsFilterState,
): MobileSessionsFilterState => ({
  status: filters.status || null,
  dateRange: filters.dateRange,
  stationIds: filters.stationIds,
  maxEnergy: filters.maxEnergy,
  maxDurationMinutes: filters.maxDurationMinutes,
});

/** Mobile-sheet draft -> page filter updates (null status -> ''). */
export const fromMobileSessionsFilters = (
  mobile: MobileSessionsFilterState,
): Partial<SessionsFilterState> => ({
  status: mobile.status ?? '',
  dateRange: mobile.dateRange,
  stationIds: mobile.stationIds,
  maxEnergy: mobile.maxEnergy,
  maxDurationMinutes: mobile.maxDurationMinutes,
});
